// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3n4Nx","footer":"ChangeClinic_footer__oKddo"};